// extracted by mini-css-extract-plugin
export var beefSammy = "BeefSammy-module--beef-sammy--tIKVW";
export var bar = "BeefSammy-module--bar--1PqQ9";
export var bar1 = "BeefSammy-module--bar-1--1qsYE BeefSammy-module--bar--1PqQ9";
export var bar2 = "BeefSammy-module--bar-2--3U4Vs BeefSammy-module--bar--1PqQ9";
export var beefSammyOpen = "BeefSammy-module--beef-sammy-open--1iiuW BeefSammy-module--beef-sammy--tIKVW";